/* eslint-disable max-len */
import React from 'react';
import { compose } from 'redux';
import withLayout from '../../../core/components/with-layout';

import {
  Container,
  Segment,
  Text,
  Header,
} from './styles';

const Rejected = () => (
  <Container>
    <Segment>
      <Header as="h3">
        Thank you for applying to the PlaybookUX participant panel.

      </Header>

      <Text>
        Our team had a chance to review your practice video. Unfortunately, we won’t be able to admit you to the panel for testing at this time since your video did not meet our quality standards. Your profile and practice test will be removed from our system.
      </Text>
    </Segment>
  </Container>
);

export default compose(withLayout({ rejected: true }))(Rejected);
